import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Spacer from "../../components/Spacer";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { 
  FormControlLabel, 
  Checkbox, 
  Typography, 
  DialogContent, 
  Box,
  Card,
  CardContent,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useNavigate, Link, useParams } from 'react-router-dom';
import Loading from "../../components/loading";
import AcceptRequestService from "../../services/AcceptRequestService";
import Message from "../tool-accepted/Message";
import LoadingSimpleBackdrop from "../tool-accepted/LoadingSimpleBackdrop";
import RapportMissionService from "../../services/RapportMissionService";
import MainContainer from "../../components/MainContainer";
import { headerData } from "../../data/modules/my-validations-header";
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(8),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      paddingBottom: theme.spacing(8),
    },
  },
  btnValidate: {
    backgroundColor: '#4caf50',
    color: 'white',
    '&:hover': {
      backgroundColor: '#45a049',
    },
    '&:disabled': {
      backgroundColor: '#a5d6a7',
      color: 'white',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      fontSize: '0.85rem',
      padding: '10px 16px',
    },
  },
  btnModify: {
    backgroundColor: '#ff9800',
    color: 'white',
    '&:hover': {
      backgroundColor: '#fb8c00',
    },
    '&:disabled': {
      backgroundColor: '#ffcc80',
      color: 'white',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      fontSize: '0.85rem',
      padding: '10px 16px',
    },
  },
  header: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(4),
    fontWeight: 200,
    fontSize: '1.2rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
      marginBottom: theme.spacing(3),
    },
  },
  value: {
    marginBottom: "20px !important",
    [theme.breakpoints.down('xs')]: {
      marginBottom: "8px !important",
      fontSize: '0.85rem',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: "12px !important",
      fontSize: '0.9rem',
    },
  },
  label: {
    fontWeight: "bold",
    marginBottom: "20px !important",
    [theme.breakpoints.down('xs')]: {
      marginBottom: "4px !important",
      fontSize: '0.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: "8px !important",
      fontSize: '0.85rem',
    },
  },
  section: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  validationSection: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  actionButton: {
    marginBottom: "20px",
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: '12px',
      fontSize: '0.8rem',
      padding: '10px 16px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '14px',
      fontSize: '0.85rem',
    },
  },
  observationsPreview: {
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  observationItem: {
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    backgroundColor: '#fff',
    borderRadius: theme.spacing(0.5),
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.25),
    },
  },
  observationLabel: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
    display: 'block',
    marginBottom: theme.spacing(0.5),
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.85rem',
    },
  },
  observationValue: {
    fontSize: '0.9rem',
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.85rem',
    },
  },
  validationSummary: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#e8f5e9',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  validationSummaryWarning: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: '#fff3e0',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  observationTextField: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(1.5),
      '& .MuiInputBase-root': {
        fontSize: '0.85rem',
      },
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  cardContent: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(1.5),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1.75),
    },
  },
  infoLabel: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    fontSize: '0.85rem',
    marginBottom: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      marginBottom: theme.spacing(0.25),
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
    },
  },
  infoValue: {
    fontSize: '1rem',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
  observationDialog: {
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0.5),
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
    },
  },
  dialogActions: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      gap: theme.spacing(1),
      padding: theme.spacing(1.5),
      '& > *': {
        width: '100%',
      },
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
      '& > *': {
        width: '100%',
      },
    },
  },
  passwordDialog: {
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(0.5),
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
    },
  },
  passwordActions: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      gap: theme.spacing(1),
      padding: theme.spacing(1.5),
      '& > *': {
        width: '100%',
      },
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: theme.spacing(1),
      padding: theme.spacing(2),
      '& > *': {
        width: '100%',
      },
    },
  },
  mobileInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  step1Title: {
    textAlign: "center",
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem',
    },
  },
  step1Grid: {
    padding: "10px",
    [theme.breakpoints.down('xs')]: {
      padding: "5px",
    },
  },
  gridItem: {
    height: "25px",
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(6),
    },
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      alignItems: 'flex-start',
    },
  },
  actionButtonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
  },
  observationHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(1),
    },
  },
  dialogTitle: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
      fontSize: '1rem',
    },
  },
  // Styles pour le scroll mobile
  pageWrapper: {
    height: '100%',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    position: 'relative',
    paddingBottom: 0,
  },
  contentArea: {
    flex: 1,
    overflow: 'visible',
    paddingBottom: theme.spacing(2),
  },
  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  scrollRoot: {
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    flex: 1,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      height: '100vh',
      maxHeight: '100%',
    },
  },
}));

export default function RapportMission() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [missionData, setMissionData] = useState(null);
  const [openValidateRequest, setOpenValidateRequest] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [openObservationDialog, setOpenObservationDialog] = useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [validationStatus, setValidationStatus] = useState({
    validate: false,
    modify: false,
    autres: "",
    methodologie: "",
    resultat: "",
    constat: "",
    details: "",
    deroule: ""        
  });
  
  const [message, setMessage] = useState({
    openMessage: false,
    color: "green",
    messageInfo: "",
  });
  
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL_PDF_MIS;
  
  const handleValidationChange = (event) => {
    const { name, checked } = event.target;
    
    setValidationStatus(prev => ({
      ...prev,
      [name]: checked,
      ...(name === 'validate' && { modify: !checked }),
      ...(name === 'modify' && { validate: !checked })
    }));
    
    if (name === "modify" && checked) {
      setOpenObservationDialog(true);
    }
  };

  const handleObservationChange = (event) => {
    const { name, value } = event.target;
    setValidationStatus(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCloseObservationDialog = () => {
    setOpenObservationDialog(false);
  };

  const handleEditObservations = () => {
    setOpenObservationDialog(true);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordError("");
  };

  const handleCloseValidateRequest = () => {
    setOpenValidateRequest(false);
    setPassword("");
    setPasswordError("");
    setConfirmationMessage("");
  };

  const handleOpenConfirmation = () => {
    if (validationStatus.validate) {
      setConfirmationMessage("✅ Vous êtes sur le point de VALIDER ce rapport de mission. Cette action est irréversible.");
    } else if (validationStatus.modify) {
      setConfirmationMessage("⚠️ Vous êtes sur le point de DEMANDER DES MODIFICATIONS pour ce rapport de mission. Des observations seront envoyées au demandeur.");
    } else {
      setConfirmationMessage("❌ Veuillez sélectionner une action (Valider ou À modifier) avant de continuer.");
      return;
    }
    setOpenValidateRequest(true);
  };

  const handleSubmitValidation = async () => {
    if (!password) {
      setPasswordError("Mot de passe requis");
      return;
    }
    
    setLoading(true);
    
    try {
      const verifyResult = await AcceptRequestService.verifyMdp(password, 2);
      
      if (verifyResult.status) {
        const status = validationStatus.validate ? "validated" : "needs_modification";
        
        const observationsToSend = {
          methodologie: validationStatus.methodologie || "",
          resultat: validationStatus.resultat || "",
          constat: validationStatus.constat || "",
          deroule: validationStatus.deroule || "",
          details: validationStatus.details || "",
          autres: validationStatus.autres || ""
        };
        
        const result = await RapportMissionService.validatemission(id, observationsToSend, status);
        
        const successMessage = validationStatus.validate 
          ? "✅ Rapport de mission validé avec succès !" 
          : "📝 Demande de modification envoyée avec succès !";
        
        setMessage({
          ...message,
          openMessage: true,
          color: "green",
          messageInfo: result.message || successMessage,
        });
        
        setTimeout(function () { 
          navigate("/me/validations"); 
        }, 1500);
        
      } else {
        throw new Error(verifyResult.message || "Mot de passe incorrect");
      }
    } catch (error) {
      setMessage({
        ...message,
        openMessage: true,
        color: "red",
        messageInfo: error.message || "Erreur, veuillez essayer à nouveau.",
      });
    } finally {
      setLoading(false);
      setOpenValidateRequest(false);
      setConfirmationMessage("");
    }
  };

  const handleCloseMessage = () => {
    setMessage(prev => ({ ...prev, openMessage: false }));
  };

  const hasObservations = () => {
    return validationStatus.methodologie || 
           validationStatus.resultat || 
           validationStatus.constat || 
           validationStatus.deroule || 
           validationStatus.details || 
           validationStatus.autres;
  };

  const getObservationCount = () => {
    let count = 0;
    if (validationStatus.methodologie && validationStatus.methodologie.trim() !== "") count++;
    if (validationStatus.resultat && validationStatus.resultat.trim() !== "") count++;
    if (validationStatus.constat && validationStatus.constat.trim() !== "") count++;
    if (validationStatus.deroule && validationStatus.deroule.trim() !== "") count++;
    if (validationStatus.details && validationStatus.details.trim() !== "") count++;
    if (validationStatus.autres && validationStatus.autres.trim() !== "") count++;
    return count;
  };

  const renderObservationField = (label, value) => {
    if (value && value.trim() !== "") {
      return (
        <div className={classes.observationItem}>
          <Typography variant="subtitle2" className={classes.observationLabel}>
            {label} :
          </Typography>
          <Typography variant="body2" className={classes.observationValue}>
            {value}
          </Typography>
        </div>
      );
    }
    return null;
  };

  const isActionSelected = () => {
    return validationStatus.validate || validationStatus.modify;
  };

  const getConfirmButtonText = () => {
    if (validationStatus.validate) return "✓ Valider le rapport";
    if (validationStatus.modify) return "✏️ Demander des modifications";
    return "Confirmer";
  };

  const getConfirmButtonStyle = () => {
    if (validationStatus.validate) return classes.btnValidate;
    if (validationStatus.modify) return classes.btnModify;
    return "";
  };

  useEffect(() => {
    setOpenLoadingSimpleBackdrop(true);
    RapportMissionService.detailsrapportmission(id)
      .then((result) => {
        if (result && result.data) {
          setMissionData(result.data);
        }
      })
      .catch((error) => {
        setMessage({
          openMessage: true,
          color: "red",
          messageInfo: "Erreur lors du chargement des données",
        });
      })
      .finally(() => {
        setOpenLoadingSimpleBackdrop(false);
      });
  }, [id]);

  if (!missionData) {
    return (
      <MainContainer {...headerData}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      </MainContainer>
    );
  }

  return (
    <MainContainer {...headerData}>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Message 
        open={message.openMessage} 
        color={message.color} 
        messageInfo={message.messageInfo} 
        handleClose={handleCloseMessage} 
      /> 
      
      <Box className={classes.scrollRoot}>
        <Box className={classes.root}>
          <Typography variant="h5" className={classes.header}>
            Validation du rapport de mission
          </Typography>

          <Card className={classes.section}>
            <CardContent className={classes.cardContent}>
              {/* Version desktop - 2 colonnes */}
              {!isMobile && !isTablet ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle1" className={classes.label}>
                      Nom et Prénom du demandeur: 
                    </Typography>
                    <Typography variant="subtitle1" className={classes.label}>
                      Objet de la mission:
                    </Typography>
                    <Typography variant="subtitle1" className={classes.label}>
                      Période:
                    </Typography>
                    <Typography variant="subtitle1" className={classes.label}>
                      Lieu:
                    </Typography>
                    <Typography variant="subtitle1" className={classes.label}>
                      Direction de destination:
                    </Typography>
                    <Typography variant="subtitle1" className={classes.label}>
                      Missionnaires:
                    </Typography>

                    {missionData.observation && (
                      <Typography variant="subtitle1" className={classes.label}>
                        Dernière observation validation rapport de mission:
                      </Typography>
                    )}
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" className={classes.value}>
                      {missionData.nom_complet || missionData.nom || "Non spécifié"}
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {missionData.mission_title || "Non spécifié"}
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      Du {missionData.date_debut} au {missionData.date_end}
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {missionData.lieu || "Non spécifié"}
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {missionData.direction_name || "Non spécifié"}
                    </Typography>
                    <Typography variant="body1" className={classes.value}>
                      {Array.isArray(missionData.missionaires)
                        ? missionData.missionaires.join(", ")
                        : missionData.missionaires || "Non spécifié"}
                    </Typography>

                    {missionData.observation && (
                      <Box className={classes.observationsPreview}>
                        <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                          Observations précédentes :
                        </Typography>
                        <ul style={{ paddingLeft: '20px', margin: 0 }}>
                          {missionData.observation.nom && (
                            <li>Demandeur de modification : {missionData.observation.nom}</li>
                          )}
                          {missionData.observation.methodologie && (
                            <li>Méthodologie : {missionData.observation.methodologie}</li>
                          )}
                          {missionData.observation.resultat && (
                            <li>Résultat : {missionData.observation.resultat}</li>
                          )}
                          {missionData.observation.details && (
                            <li>Détails : {missionData.observation.details}</li>
                          )}
                          {missionData.observation.deroule && (
                            <li>Déroulement de la mission : {missionData.observation.deroule}</li>
                          )}
                          {missionData.observation.autres && (
                            <li>Autres : {missionData.observation.autres}</li>
                          )}
                        </ul>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              ) : (
                /* Version mobile/tablette - Affichage en colonne avec libellé + valeur */
                <Box className={classes.mobileInfoContainer}>
                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Nom et Prénom du demandeur</Typography>
                    <Typography className={classes.infoValue}>
                      {missionData.nom_complet || missionData.nom || "Non spécifié"}
                    </Typography>
                  </Box>

                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Objet de la mission</Typography>
                    <Typography className={classes.infoValue}>
                      {missionData.mission_title || "Non spécifié"}
                    </Typography>
                  </Box>

                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Période</Typography>
                    <Typography className={classes.infoValue}>
                      Du {missionData.date_debut} au {missionData.date_end}
                    </Typography>
                  </Box>

                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Lieu</Typography>
                    <Typography className={classes.infoValue}>
                      {missionData.lieu || "Non spécifié"}
                    </Typography>
                  </Box>

                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Direction de destination</Typography>
                    <Typography className={classes.infoValue}>
                      {missionData.direction_name || "Non spécifié"}
                    </Typography>
                  </Box>

                  <Box className={classes.infoItem}>
                    <Typography className={classes.infoLabel}>Missionnaires</Typography>
                    <Typography className={classes.infoValue}>
                      {Array.isArray(missionData.missionaires)
                        ? missionData.missionaires.join(", ")
                        : missionData.missionaires || "Non spécifié"}
                    </Typography>
                  </Box>

                  {missionData.observation && (
                    <Box className={classes.infoItem}>
                      <Typography className={classes.infoLabel}>Dernière observation</Typography>
                      <Box className={classes.observationsPreview}>
                        <ul style={{ paddingLeft: '20px', margin: 0 }}>
                          {missionData.observation.nom && (
                            <li>Demandeur de modification : {missionData.observation.nom}</li>
                          )}
                          {missionData.observation.methodologie && (
                            <li>Méthodologie : {missionData.observation.methodologie}</li>
                          )}
                          {missionData.observation.resultat && (
                            <li>Résultat : {missionData.observation.resultat}</li>
                          )}
                          {missionData.observation.details && (
                            <li>Détails : {missionData.observation.details}</li>
                          )}
                          {missionData.observation.deroule && (
                            <li>Déroulement de la mission : {missionData.observation.deroule}</li>
                          )}
                          {missionData.observation.autres && (
                            <li>Autres : {missionData.observation.autres}</li>
                          )}
                        </ul>
                      </Box>
                    </Box>
                  )}
                </Box>
              )}

              <Box mt={2}>
                <Button 
                  component={Link}
                  to={`${apiUrl}/${missionData.filename}`}
                  target="_blank"
                  variant="outlined"
                  color="primary"
                  className={classes.actionButton}
                  fullWidth={isMobile || isTablet}
                  size={isMobile ? "small" : "medium"}
                >
                  Visualiser le rapport de mission (PDF)
                </Button>
              </Box>
            </CardContent>
          </Card>

          {/* Section de validation */}
          <Card className={classes.section}>
            <CardContent className={classes.cardContent}>
              <Box className={classes.validationSection}>
                <Typography variant="h6" style={{ marginBottom: '16px', color: '#1976d2' }}>
                  Décision de validation
                </Typography>
                
                <Box className={classes.checkboxContainer}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={validationStatus.validate}
                        onChange={handleValidationChange}
                        name="validate"
                        color="primary"
                      />
                    }
                    label="VALIDER"
                  />
                  
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={validationStatus.modify}
                        onChange={handleValidationChange}
                        name="modify"
                        color="secondary"
                      />
                    }
                    label="A MODIFIER"
                  />
                </Box>

                {/* Affichage des observations */}
                {validationStatus.modify && (
                  <Box className={classes.observationsPreview}>
                    <Box className={classes.observationHeader}>
                      <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#1976d2' }}>
                        📝 Observations et recommandations {getObservationCount() > 0 && `(${getObservationCount()} éléments)`}
                      </Typography>
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={handleEditObservations}
                        startIcon={<EditIcon />}
                        color="primary"
                        fullWidth={isMobile || isTablet}
                      >
                        Modifier
                      </Button>
                    </Box>
                    
                    {hasObservations() ? (
                      <Box>
                        {renderObservationField("📋 Méthodologie", validationStatus.methodologie)}
                        {renderObservationField("🎯 Résultats attendus", validationStatus.resultat)}
                        {renderObservationField("📊 Constat et recommandations", validationStatus.constat)}
                        {renderObservationField("🚀 Déroulement de la mission", validationStatus.deroule)}
                        {renderObservationField("ℹ️ Détails supplémentaires", validationStatus.details)}
                        {renderObservationField("💡 Autres observations", validationStatus.autres)}
                      </Box>
                    ) : (
                      <Box textAlign="center" py={3}>
                        <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                          Aucune observation saisie. Cliquez sur "Modifier" pour ajouter des observations.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Résumé de la décision */}
                {isActionSelected() && (
                  <Box className={validationStatus.validate ? classes.validationSummary : classes.validationSummaryWarning}>
                    <Box display="flex" alignItems="center" gap={1} flexDirection={isMobile ? "column" : "row"} textAlign={isMobile ? "center" : "left"}>
                      {validationStatus.validate ? (
                        <CheckCircleIcon style={{ color: '#4caf50' }} />
                      ) : (
                        <WarningIcon style={{ color: '#ff9800' }} />
                      )}
                      <Typography variant="body2">
                        {validationStatus.validate 
                          ? "Vous allez VALIDER ce rapport de mission. Aucune modification ne sera demandée."
                          : "Vous allez DEMANDER DES MODIFICATIONS pour ce rapport de mission. Les observations ci-dessus seront envoyées au demandeur."
                        }
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>

          <Box className={classes.actionButtonContainer}>
            <Button 
              variant="contained"
              className={getConfirmButtonStyle()}
              onClick={handleOpenConfirmation}
              disabled={!isActionSelected()}
              startIcon={validationStatus.validate ? <CheckCircleIcon /> : validationStatus.modify ? <WarningIcon /> : null}
              fullWidth={isMobile || isTablet}
              size={isMobile ? "small" : "medium"}
            >
              {getConfirmButtonText()}
            </Button>
            <Button 
              variant="contained" 
              color="error" 
              onClick={() => navigate("/me/validations")}
              fullWidth={isMobile || isTablet}
              size={isMobile ? "small" : "medium"}
            >
              Annuler
            </Button>
            
          </Box>
        </Box>
      </Box>

      {/* Dialogue d'observations */}
      <Dialog 
        open={openObservationDialog} 
        onClose={handleCloseObservationDialog}
        maxWidth="md"
        fullWidth
        className={classes.observationDialog}
        fullScreen={isMobile}
        scroll="paper"
      >
        <DialogTitle className={classes.dialogTitle} style={{ backgroundColor: '#ff9800', color: 'white' }}>
          ✏️ Observations et recommandations
        </DialogTitle>
        <DialogContent className={classes.dialogContent} dividers>
          <Typography variant="body2" style={{ marginBottom: '20px', color: '#666' }}>
            Veuillez préciser les observations et recommandations pour chaque aspect du rapport de mission.
          </Typography>
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="📋 Méthodologie"
            name="methodologie"
            value={validationStatus.methodologie}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Commentaires sur la méthodologie utilisée..."
          />
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="🎯 Résultats attendus"
            name="resultat"
            value={validationStatus.resultat}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Commentaires sur les résultats attendus..."
          />
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="📊 Constat et recommandations"
            name="constat"
            value={validationStatus.constat}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Constat général et recommandations..."
          />
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="🚀 Déroulement de la mission"
            name="deroule"
            value={validationStatus.deroule}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Commentaires sur le déroulement de la mission..."
          />
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="ℹ️ Détails supplémentaires"
            name="details"
            value={validationStatus.details}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Informations complémentaires..."
          />
          
          <TextField
            fullWidth
            multiline
            rows={isMobile ? 2 : 3}
            label="💡 Autres observations"
            name="autres"
            value={validationStatus.autres}
            onChange={handleObservationChange}
            variant="outlined"
            className={classes.observationTextField}
            placeholder="Autres remarques ou suggestions..."
          />
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button 
            onClick={handleCloseObservationDialog} 
            color="secondary"
            variant="contained"
            style={{ backgroundColor: '#f50057', color: '#FFFFFF' }}
            fullWidth={isMobile || isTablet}
          >
            Annuler
          </Button>
          <Button 
            onClick={handleCloseObservationDialog} 
            color="primary"
            variant="contained"
            style={{ backgroundColor: '#4caf50', color: '#FFFFFF' }}
            fullWidth={isMobile || isTablet}
          >
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Password confirmation dialog */}
      <Dialog 
        open={openValidateRequest} 
        onClose={handleCloseValidateRequest} 
        aria-labelledby="form-dialog-title1" 
        fullWidth 
        maxWidth="sm"
        className={classes.passwordDialog}
        fullScreen={isMobile}
        scroll="paper"
      >
        <DialogTitle className={classes.dialogTitle} style={{ 
          backgroundColor: validationStatus.validate ? '#4caf50' : '#ff9800', 
          color: 'white',
        }}>
          {validationStatus.validate ? "Confirmation de validation" : "Confirmation de demande de modification"}
        </DialogTitle>
        <DialogContent dividers>
          <div className={classes.root}>
            <Box mb={2} p={isMobile ? 1.5 : 2} bgcolor={validationStatus.validate ? '#e8f5e9' : '#fff3e0'} borderRadius={1}>
              <Typography variant="body2" style={{ fontWeight: '500', fontSize: isMobile ? '0.85rem' : '0.9rem' }}>
                {confirmationMessage}
              </Typography>
            </Box>
            <div>
              <h3 className={classes.step1Title}>Votre mot de passe</h3>
            </div>
            <Grid className={classes.step1Grid} container>
              <Grid className={classes.gridItem} item xs={12}>
                <TextField
                  fullWidth
                  id="outlined-basic"
                  size={isMobile ? "medium" : "small"}
                  label="Votre mot de passe"
                  variant="outlined"
                  value={password}
                  name="mdp"
                  type="password"
                  onChange={handlePasswordChange}
                  error={!!passwordError}
                  helperText={passwordError}
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
              <Grid item xs={12}>
                <Spacer y={3} />
                {isLoading && <Loading />}
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions className={classes.passwordActions}>
          <Button 
            style={{ backgroundColor: "#f50057", color: "#FFFFFF" }} 
            onClick={handleCloseValidateRequest} 
            color="secondary" 
            variant="contained"
            fullWidth={isMobile || isTablet}
          >
            Annuler
          </Button>
          <Button 
            style={{ 
              backgroundColor: validationStatus.validate ? "#4caf50" : "#ff9800", 
              color: "#FFFFFF" 
            }} 
            onClick={handleSubmitValidation} 
            variant="contained"
            disabled={isLoading}
            fullWidth={isMobile || isTablet}
          >
            {validationStatus.validate ? "Valider" : "Demander modification"}
          </Button>
        </DialogActions>
      </Dialog>
    </MainContainer>
  );
}